import { ProfilePasswordComponent } from './profile-password/profile-password.component';
import { ProfileListComponent } from './profile-list/profile-list.component';
export var profileRoutes = [
    {
        path: 'profile',
        children: [
            {
                path: 'password',
                component: ProfilePasswordComponent
            },
            {
                path: 'list',
                component: ProfileListComponent
            }
        ],
    }
];
var ProfileRoutingModule = (function () {
    function ProfileRoutingModule() {
    }
    return ProfileRoutingModule;
}());
export { ProfileRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/features/profile/profile-routing.module.ts.pre-build-optimizer.js